module.exports = __webpack_public_path__ + "static/media/view student talent.8ab51d0f.svg";